import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=1368c898&scoped=true&"
var script = {}
import style0 from "./layout.vue?vue&type=style&index=0&id=1368c898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368c898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1368c898')) {
      api.createRecord('1368c898', component.options)
    } else {
      api.reload('1368c898', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=1368c898&scoped=true&", function () {
      api.rerender('1368c898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/layout.vue"
export default component.exports